declare global {
  interface Window {
    dataLayer: any;
    ACC: any;
    timezoneDebugMode: (value: boolean) => void;
  }
}

export class DataLayer {
  dataLayer: any;
}

export class TTEcommerceAnalyticsTrackingData {
  productName: string;
  productId: string;
  productPrice: string;
  productBrand: string;
  category: string;
  variant: string;
  quantity: string;
  currency: string;
}

export type AddToCartGAModel = {
  addToCartData: TTEcommerceAnalyticsTrackingData;
  quantity: number;
  productCode: string;
  cartData: {
    origin: string;
  };
};

export const convertToAddToCartEvModel = (
  product: TTEcommerceAnalyticsTrackingData,
  data: EventData
): AddToCartGAModel => ({
  addToCartData: product,
  quantity: data.quantity,
  cartData: {
    origin: data.origin,
  },
  productCode: data.productCode,
});

export enum EventType {
  addToCart = "addToCart",
  productClick = "productClick",
  addToWishlist = "add_to_wishlist",
}

export type GoogleAnalyticsEvent = {
  ecommerce: any;
  event?: EventType;
};

export type EventData = {
  origin: string;
  productCode: string;
  productUrl?: string;
  position?: number;
  quantity?: number;
  productBrand?: string;
};

export const createClickEventData = (
  origin: string,
  product: any,
  contextPath: string,
  index: number
) => ({
  origin,
  productCode: product.codes ? product.codes.code : product.code,
  productUrl: product.url && `${contextPath}${product.url}`,
  position: index,
});

export const createAddToWishlistEventData = (
  origin: string,
  productCode: string,
  quantity: number
) => ({
  origin,
  productCode,
  quantity,
});
